import {makeAutoObservable} from "mobx";
import {SearchObject} from "app/common/Model/SearchObject";
import {
    deleteICDCodeConcept,
    getICDCodeConceptById,
    getICDCodeListConceptById,
    pagingICDCodeConcept,
    saveICDCodeConcept,
    saveICDCodeListConcept
} from 'app/services/ICDCodeConceptService';
import {checkSearchObject} from "app/common/LocalFunction";
import {toast} from "react-toastify";
import {MedicationRequestForm} from "app/common/Model/MedicationRequestForm";

export default class ICDCodeConceptStore {
    searchICDCodeConcept = new SearchObject();
    pageICDCodeConcept = null;
    selectedICDCodeConcept = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteICDCodeConcept = false;
    isViewListByIcd = false;

    constructor() {
        makeAutoObservable(this);
    }


    pagingICDCodeConcept = async (searchObj) => {
        let newSearchObj = {...this.searchICDCodeConcept, ...searchObj}
        return await pagingICDCodeConcept(newSearchObj)
            .then(({data}) => {
                this.pageICDCodeConcept = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu có lỗi");
            })
    }

    handleChangeFormSearch = (searchICDCodeConcept) => {
        this.searchICDCodeConcept = checkSearchObject(this.searchICDCodeConcept, searchICDCodeConcept);
        this.pagingICDCodeConcept();
    }

    handleOpenFormCreateOrEdit = (icdCodeConceptId) => {
        if (Boolean(icdCodeConceptId)) {
            getICDCodeConceptById(icdCodeConceptId)
                .then(({data}) => {
                    this.selectedICDCodeConcept = data;
                    this.openFormCreateOrEdit = true;
                    this.isViewListByIcd = false;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedICDCodeConcept = new MedicationRequestForm();
            this.openFormCreateOrEdit = true;
            this.isViewListByIcd = false;
        }
    }

    handleOpenFormCreateOrEditList = (icdCodeConceptId) => {
        if (Boolean(icdCodeConceptId)) {
            getICDCodeListConceptById(icdCodeConceptId.concept?.id)
                .then(({data}) => {
                    this.selectedICDCodeConcept = data;
                    this.openFormCreateOrEdit = true;
                    this.isViewListByIcd = true;
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Lấy dữ liệu có lỗi");
                })
        } else {
            this.selectedICDCodeConcept = new MedicationRequestForm();
            this.openFormCreateOrEdit = true;
            this.isViewListByIcd = true;
        }
    }

    saveICDCodeConcept = async (icdCodeConcept, {setSubmitting}) => {
        await saveICDCodeConcept(icdCodeConcept).then(() => {
            this.selectedICDCodeConcept = null;
            toast.success("Lưu thành công!");
            this.handleClosePopup();
            this.pagingICDCodeConcept();
        })
            .catch(error => {
                console.error(error);
                toast.error("Có lỗi xảy ra, vui lòng thử lại");
            })
            .finally(() => setSubmitting(false))
    }

    saveICDCodeListConcept = async (icdCodeConcept, {setSubmitting}) => {
        await saveICDCodeListConcept(icdCodeConcept).then(() => {
            this.selectedICDCodeConcept = null;
            toast.success("Lưu thành công!");
            this.handleClosePopup();
            this.pagingICDCodeConcept();
        })
            .catch(error => {
                console.error(error);
                toast.error("Có lỗi xảy ra, vui lòng thử lại");
            })
            .finally(() => setSubmitting(false))
    }

    handleDeleteICDCodeConcept = (icdCodeConcept) => {
        this.selectedICDCodeConcept = {id: icdCodeConcept?.id};
        this.openConfirmDeleteICDCodeConcept = true;
    }

    handleConfirmDeleteICDCodeConcept = () => deleteICDCodeConcept(this?.selectedICDCodeConcept?.id)
        .then(() => {
            if (this.searchICDCodeConcept.pageIndex > 1 && this.pageICDCodeConcept?.content?.length === 1) {
                this.searchICDCodeConcept.pageIndex -= 1;
            }
            toast.success("Xóa mẫu đơn thuốc thành công!")
            this.handleClosePopup();
            this.pagingICDCodeConcept();
        })
        .catch(err => {
            console.error(err);
            toast.error("Xóa mẫu đơn thuốc có lỗi");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteICDCodeConcept = false;
    }

    resetStore = () => {
        this.searchICDCodeConcept = new SearchObject();
        this.pageICDCodeConcept = null;
        this.selectedICDCodeConcept = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteICDCodeConcept = false;
        this.isViewListByIcd = false;
    }

}